import r2wc from "@r2wc/react-to-web-component";
import reportWebVitals from "./reportWebVitals";
import { ContactForm } from "./ContactForm";
import "./i18n";
import "./styles/main.css";

const MFContactForm = r2wc(ContactForm);
customElements.define("mf-formulario-escribenos", MFContactForm);

// Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
